export const routes = [
  {
    path: '/sp/welcome',
    component: () => import(/* webpackChunkName: "sp-welcome" */ './Welcome'),
    name: 'welcome'
  }
]
